import ICollectionParams from '../../models/params/ICollectionParams';
import { IStoreCollection } from '../../models/collections/IStoreCollection';
import { apiV2 } from '../../api/ApiV2';

const perPageValues = [10, 20, 50, 100, 1000];
const defaultOrderCollection: IStoreCollection = {
  perPage: perPageValues[4],
  pageNo: 1,
  sortColumn: 'ID',
  sortDirection: '-',
  totalCount: 0,
  itemsCount: 0,
  items: [],
  dataObjectParams: {
    _view_nested: true
  }
};

const StoresLoader = (
  collectionParams: ICollectionParams = defaultOrderCollection
) =>
  apiV2.crud
    .readCollection({
      dataObjectName: 'MerchStore',
      collectionParams: collectionParams
    })
    .then(resp => resp.itemsCollection as IStoreCollection);

export default StoresLoader;
